﻿const newsfeedConfigBlock = (() => {
    for (const configBlock of document.querySelectorAll("div.newsfeed-config-block")) {
        const categoryFilters = configBlock.querySelectorAll('ul.category-filters');
        const checkboxes = configBlock.querySelectorAll("input[type='checkbox']");

        for (const radio of configBlock.querySelectorAll("input[type='radio']")) {
            radio.addEventListener('change', (event) => {
                handleRadioChange(event, categoryFilters, checkboxes);
            });
        }

        for (const categoryFilter of categoryFilters) {
            const selectAllCheckbox = categoryFilter.querySelector("input[type='checkbox'].select-all");
            const categoryCheckboxes = Array.from(categoryFilter.querySelectorAll("input[type='checkbox']:not(.select-all)"));

            selectAllCheckbox?.addEventListener('change', (event) => {
                handleSelectAllCheckboxChange(event, categoryCheckboxes);
            });

            for (const checkbox of categoryCheckboxes) {
                checkbox.addEventListener('change', (event) => {
                    handleCategoryCheckboxChange(event, categoryCheckboxes, selectAllCheckbox);
                })
            }
        }
    }

    const handleRadioChange = (event, categoryFilters, checkboxes) => {
        for (const checkbox of checkboxes) {
            checkbox.checked = false;
            checkbox.indeterminate = false;
        }

        for (const categoryFilter of categoryFilters) {
            categoryFilter.classList.remove('selected');
        }

        const currentCategoryFilter = event.target.closest('li')
            .querySelector('ul.category-filters');
        currentCategoryFilter?.classList?.add('selected');
    }

    const handleCategoryCheckboxChange = (event, checkboxes, checkboxSelectAll) => {
        if (!checkboxSelectAll)
            return;

        checkboxSelectAll.indeterminate = !checkboxes.every(x => x.checked == event.target.checked);
        checkboxSelectAll.checked = !checkboxSelectAll.indeterminate && event.target.checked;
    }

    const handleSelectAllCheckboxChange = (event, checkboxes) => {
        for (const checkbox of checkboxes) {
            checkbox.checked = event.target.checked;
        }
    }
})();